/**
 * I TESTI LEGALI DELLA SKIN, per chi li scrive fuori dal piede di pagina.
 *
 * La riga della licenza e il testo del gioco responsabile li scrive il
 * backoffice (Moduli › Piè di pagina): il piede del sito li mostra, e la
 * giocata stampata li porta in fondo al foglio. Stanno qui perche' le due
 * parti scrivano LA STESSA riga: prima fraseLegale viveva dentro PiedeNova.
 *
 * COSA NON FA: non inventa una licenza. Se la skin non ha scritto la societa'
 * la riga della licenza resta vuota, sul sito come sulla carta.
 */
import i18next from 'i18next';
import {skinCorrente} from '../skin';
import {pieDiPagina} from '../moduli/leggi';

const tDiSerie = (chiave, valori) => i18next.t(chiave, valori);

/** La riga della licenza composta dai campi del backoffice (la società c'è sempre, il resto se scritto). */
export function fraseLegale(l, t = tDiSerie) {
  let riga = t('{{sito}} è gestito da {{societa}}', {sito: (skinCorrente() || {}).name || t('Il sito'), societa: l.societa, interpolation: {escapeValue: false}});
  if (l.sede) riga += ', ' + l.sede;
  if (l.registrazione) riga += ', ' + t('n. di registrazione {{numero}}', {numero: l.registrazione, interpolation: {escapeValue: false}});
  if (l.ente || l.licenza) {
    riga += ', ' + t('con licenza');
    if (l.ente) riga += ' ' + l.ente;
    if (l.licenza) riga += ' ' + t('n. {{numero}}', {numero: l.licenza, interpolation: {escapeValue: false}});
  }
  return riga + '.';
}

/**
 * I due testi del foglio stampato: la riga della licenza (vuota se la skin
 * l'ha spenta o non l'ha scritta) e il testo del gioco responsabile, quello
 * della skin o, se non l'ha scritto, la frase di serie del piede.
 *
 * Il gioco responsabile sulla carta c'e' sempre, anche quando la skin ha
 * spento la sua colonna nel piede: il foglio gira da solo, senza il sito
 * intorno.
 *
 * @param piede il piede di pagina gia' letto (pieDiPagina()), per le prove
 * @returns {{legale: string, responsabile: string}}
 */
export function testiStampa(piede) {
  let p = piede;
  if (!p) {
    try {
      p = pieDiPagina();
    } catch (e) {
      p = {};
    }
  }
  const legale = (p && p.legale) || {};
  const rg = (p && p.giocoResponsabile) || {};
  const riga = legale.acceso === false ? ''
    : (testo(legale.testo) || (testo(legale.societa) ? fraseLegale(legale) : ''));
  return {
    legale: riga,
    /* Senza testo della skin, la frase di serie NON ripete i 18 anni: sul
       rotolo li dice gia' la riga in grassetto sopra, sull'A4 il «18+ ·»
       davanti. Prima la carta diceva due volte la stessa cosa. */
    responsabile: testo(rg.testo)
      || i18next.t('Il gioco può causare dipendenza. Gioca responsabilmente: imposta limiti di deposito e di perdita, prenditi una pausa o autoescluditi dalla pagina Gioco responsabile.'),
  };
}

function testo(v) {
  return typeof v === 'string' ? v.trim() : '';
}
